<template>
  <div>
    <h1>Multipagos success</h1>
  </div>
</template>

<script>
export default {
    name: 'MultipagosSuccess'
}
</script>

<style scoped>
    h1 {
        color: black;
    }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/Multipagos/MultipagosSuccess.vue